import { GetStaticPaths, GetStaticProps } from "next"
import SearchByKeyword from "@views/SearchByKeyword"
import { SearchTypes } from "@components/Search"
import qs from "qs"

export default SearchByKeyword

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: true,
  }
}

export const getStaticProps: GetStaticProps = async ({
  params = {},
  preview = false,
}) => {
  const queryParams: any =
    params && params.query ? qs.parse(params.query as any) : undefined

  const searchParams: any = {}

  if (queryParams?.query) {
    searchParams.query = queryParams?.query
  }

  return {
    props: {
      preview,
      subtitle: "Search by Keyword",
      title: `"${queryParams?.query ? queryParams?.query : ""}"`,
      searchType: SearchTypes.BY_KEYWORD,
      searchParams,
    },
  }
}
